import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import classnames from 'classnames';
import * as productSearchActions from './productSearchActions';
import {GlobalHeader, BackButton} from '../common/GlobalHeader';
import moment from 'moment';
import { DayPicker } from 'react-dates';
import i18n from 'i18next';
import translations from "../translations";
import './calendar.scss'

i18n.init({
  lng: window.Flyblade.locale,
  resources: translations
});

class AddFlightContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {flash: null};
    this.setTravelDate = this.setTravelDate.bind(this);
    this.goToItinerary = this.goToItinerary.bind(this);

    moment.locale(Flyblade.locale);
  }

  componentWillMount() {
    this.props.actions.selectTravelDate(null);
    this.props.actions.calendarParameters();
  }

  setTravelDate(date) {
    let {
      minimum_departure_date,
      closed_weekdays,
      dates_with_flights
    } = this.props;

    let flightDateIndex = _.indexOf(dates_with_flights, date.format('YYYY-MM-DD')),
        hasScheduledFlight = flightDateIndex >= 0;

    if (
      !hasScheduledFlight ||
      isDisabled(date, minimum_departure_date, closed_weekdays)
    ) { return; }

    this.props.actions.selectTravelDateAndContinue(date);
  }

  goToItinerary(date) {
    window.location.href = '/booking/review-summary';
  }

  render() {
    let {
      minimum_departure_date,
      dates_with_flights,
      closed_weekdays
    } = this.props;

    return (
      <div className="page-layout">
        <GlobalHeader
          leftComponent={<BackButton onClick={this.goToItinerary} />}
          title={i18n.t('flightSearch.selectReturnDate')} />

        <div className="page-layout-body" style={{overflow: 'hidden'}}>
          <DayPicker
            numberOfMonths={12}
            orientation={'verticalScrollable'}
            onDayClick={this.setTravelDate}
            renderDay={buildDays(minimum_departure_date, dates_with_flights, closed_weekdays)}
            hideKeyboardShortcutsPanel={true}
            daySize={50}
          />
        </div>
      </div>
    )
  }
}

const isDisabled = (day, minDeparture, closedWeekdays) => {
  return (
    isBeforeMinDeparture(day, minDeparture) ||
    isClosed(day, closedWeekdays)
  );
};
const isBeforeMinDeparture = (day, minDeparture) => day.isBefore(moment(minDeparture), 'day');
const isClosed = (day, closedWeekdays) => !!closedWeekdays[day.format('dddd')];


const buildDays = (minDeparture, datesWithFlights, closedWeekdays) => {
  let lastIndexFound = 0;

  return day => {
    var flightDateIndex = _.indexOf(datesWithFlights, day.format('YYYY-MM-DD'), lastIndexFound);
    if(flightDateIndex >= 0) {
      lastIndexFound = flightDateIndex;
    }
    return (
      <Day
        day={day}
        isDisabled={isDisabled(day, minDeparture, closedWeekdays)}
        hasFlight={flightDateIndex >= 0}  />
    );
  }
}

const Day = ({day, isSelected, isDisabled, hasFlight}) => {
  return (
    <div className={classnames(
      {
        'is-disabled': !hasFlight || isDisabled,
        'has-flight': hasFlight && !isDisabled
      }
    )}>
      <span>{day.format('D')}</span>
    </div>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    minimum_departure_date: state.productSearch.minimum_departure_date,
    dates_with_flights: state.productSearch.dates_with_flights,
    closed_weekdays: state.productSearch.closed_weekdays
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(productSearchActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddFlightContainer);
